module.exports = __webpack_public_path__ + "img/drugs-2.81bf4ba1.svg";